<template>
    <router-view/>
</template>
<script>
    export default {
        beforeRouteUpdate(to, from, next) {
            if(to.name == 'ven-leads'){
                next({ name: 'ven-leads-list', replace: true })
            }else{
                next()
            }
        },
        created() {
            if(this.$route.name == 'ven-leads'){
                this.$router.replace({ name: 'ven-leads-list' })
            }
        }
  }
  </script>